import { render } from "./Mehr.vue?vue&type=template&id=7ed122e4"
import script from "./Mehr.vue?vue&type=script&lang=js"
export * from "./Mehr.vue?vue&type=script&lang=js"

import "./Mehr.vue?vue&type=style&index=0&id=7ed122e4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__